import { Event } from '../../model/Entities';
import dateService from '../../services/DateService';
import apiAxiosV2 from './CustomAxiosV2';

class EventApiV2 {
    /**
     * Returns an event by its id. The v2 endpoint keeps the path and the response of v1, so only the host differs.
     * @param eventId - the id of the event
     * @returns the event
     */
    get = async (eventId: number): Promise<Event> => {
        const response = await apiAxiosV2.get<Event>(`/v1/events/${eventId}`);
        response.data.startDate = response.data.startDate
            ? dateService.toLocal(response.data.startDate * 1000)
            : undefined;
        response.data.endDate = response.data.endDate ? dateService.toLocal(response.data.endDate * 1000) : undefined;

        return response.data;
    };
}

const eventApiV2: EventApiV2 = new EventApiV2();
export default eventApiV2;
